import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
	Button,
	Checkbox,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	FormControlLabel,
	FormHelperText,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { toast } from "react-toastify";
import { HttpStatusCodes } from "../../../utility/enums";
import { IDropDownFields } from "../../../utility/interfaces";
import {
	addNewSegment,
	getAllCommonRecords,
	updateSegment,
} from "../../../services";
import { number, object, string } from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { APIRoutes } from "../../../utility/app-routes";

type ComponentProps = {
	dialogOpen: boolean;
	handleOnClickClose: any;
	getAllRecords: any;
	data: any | undefined;
};
export function AddUpdateSegment(props: ComponentProps) {
	const formValidationSchema = object({
		name: string().required("Name is required"),
		propertyType: number().min(1, "Please select property type."),
	});
	// Yup resolver
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm({
		resolver: yupResolver(formValidationSchema),
	});

	const { dialogOpen, handleOnClickClose, data, getAllRecords } = props;
	const [name, setName] = useState("");
	const [isActive, setIsActive] = useState(true);
	const [propertyTypeId, setPropertyTypeId] = useState(0);
	const [propertyTypeList, setPropertyTypeList] = useState<IDropDownFields[]>(
		[]
	);
	const [id, setId] = useState(0);

	const handleOnClickSubmit = async () => {
		let response = null;
		if (id === null || id === 0)
			response = await addNewSegment(name, isActive, +propertyTypeId);
		else response = await updateSegment(name, isActive, +propertyTypeId, id);
		if (response?.data?.status === HttpStatusCodes.Ok) {
			await getAllRecords();
			toast.success(response.data.message);
		} else toast.error(response.data.message);
		handleOnClickClose();
	};

	const getPageLoadData = async () => {
		const { data } = await getAllCommonRecords(APIRoutes.getSegmentPageLoad);
		if (data && data.status === HttpStatusCodes.Ok) {
			setPropertyTypeList(data?.response?.propertyTypeList);
		} else {
			setPropertyTypeList([]);
			toast.error(data.message);
		}
	};

	// useEffects
	useEffect(() => {
		reset();
		setName(data?.name);
		setIsActive(data ? data.isActive : true);
		setId(data?.id || 0);
		setPropertyTypeId(data ? data.propertyTypeId : 0);

		if (dialogOpen) getPageLoadData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dialogOpen]);

	return (
		<Dialog
			open={dialogOpen}
			onClose={handleOnClickClose}
			maxWidth="xs"
			fullWidth
		>
			<DialogTitle>
				Segment
				<IconButton aria-label="Close" onClick={handleOnClickClose}>
					<CloseOutlined />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<TextField
					{...register("name")}
					error={errors?.name?.message ? true : false}
					helperText={errors?.name?.message?.toString()}
					id="name"
					label="Name"
					type="text"
					value={name}
					fullWidth
					autoFocus
					variant="outlined"
					onChange={(e) => setName(e.target.value)}
					className="mb-20"
				/>
				<FormControl fullWidth className="mb-8">
					<InputLabel id="select-label">Property type</InputLabel>
					<Select
						labelId="select-label"
						{...register("propertyType")}
						error={errors?.propertyType?.message ? true : false}
						id="parent"
						value={propertyTypeId}
						label="Parent"
						onChange={(e) => setPropertyTypeId(+e.target.value)}
					>
						<MenuItem value="0">Select</MenuItem>
						{propertyTypeList?.map((record) => {
							return (
								<MenuItem disabled={!record.isActive} value={record.id}>
									{record.text}
								</MenuItem>
							);
						})}
					</Select>
					<FormHelperText error id="component-error-text">
						<>{errors?.propertyType?.message}</>
					</FormHelperText>
				</FormControl>
				<FormControlLabel
					className="mb-ng-8"
					control={
						<Checkbox
							checked={isActive}
							onClick={() => setIsActive(!isActive)}
						/>
					}
					label="Active"
				/>
			</DialogContent>
			<DialogActions>
				<Button variant="contained" onClick={handleSubmit(handleOnClickSubmit)}>
					Submit
				</Button>
				<Button variant="outlined" onClick={handleOnClickClose}>
					Cancel
				</Button>
			</DialogActions>
		</Dialog>
	);
}
